import { Component } from 'react';
import PropTypes from 'prop-types';

export default class BlockTitle extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        children: PropTypes.node,
        /**
         * Heading level of the block title. Stays `h1` by default, because on most pages the title of
         * the main block *is* the title of the page. A page carrying its own `h1` elsewhere must pass
         * `h2` here, otherwise the document ends up with two competing first-level headings.
         */
        level: PropTypes.oneOf(['h1', 'h2']),
    };

    static defaultProps = {
        children: null,
        level: 'h1',
    };

    render() {
        const { title, children, level: Heading, ...props } = this.props;

        return (
            <div {...props} className="title-block">
                <Heading className="h1">{title}</Heading>
                {children}
            </div>
        );
    }
}
